/* tslint:disable */
/* eslint-disable */
export enum Icd10ConfigValue {
  Any = 'any',
  RiskAlgorithm = 'riskAlgorithm',
}
